<ng-template #content let-modal>
  <div class="edit-customer-invoice-credit">
    <div class="edit-customer-invoice-credit-header">
      <div class="edit-customer-invoice-credit-header-close float-end clearfix">
        <img (click)="closeModal()" src="../../../../../../assets/icons/Close.svg" alt="Close" />
      </div>
      <div class="edit-customer-invoice-credit-header-title">
        {{ 'case-economy-customer-invoices-reinvoice' | translate }}
      </div>
    </div>
    <div class="edit-customer-invoice-credit-body">
      <app-drop-down
        [name]="'case-economy-customer-invoices-debtorNo' | translate"
        [items]="debtors"
        [(selectedItemId)]="selectedId"
      ></app-drop-down>
      <app-text-box
        [maxTextLength]="250"
        [name]="'case-economy-sos-services-modify-comment' | translate"
        [(value)]="actionComment"
      ></app-text-box>
    </div>
    <div class="modal-footer">
      <div class="d-flex justify-content-end">
        <button (click)="creditSalesOrder()" [disabled]="saveInProgress">
          {{ 'case-economy-sos-services-modify-save' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
